<template>
<!-- <router-view /> -->
 <div class="d-flex" v-if="isSettingPath">
    <div  style="width: 300px;">
      <Sidebar />
    </div>
    <div class="flex-grow-1 bg-white">
      <router-view />
    </div>
  </div>

    <router-view v-else/>

</template>

<script>
import Sidebar from '@/components/Sidebar_setting_component.vue'
export default {
  name: 'App',
  components: {
    Sidebar
  },
   computed: {
    isSettingPath() {
      return this.$route.path.startsWith('/setting')
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Allerta+Stencil&display=swap');
@font-face {
    font-family: Maehongson;
    src: url(../src/assets/front/Maehongson.ttf);
}

div{
  font-family:  Maehongson;
}
h1{
  font-family:  Maehongson;
}

.allerta-stencil-regular {
  font-family: "Allerta Stencil", sans-serif;
  font-weight: 400;
  font-style: normal;
}


#app {
  font-family:  Maehongson;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
